import { FormTableCellDirtyProvider } from "@/contexts/FormTableCellDirtyContext";
import { memo, PropsWithChildren } from "react";
import DataTable from "@/components/data-table";
import { useDataTableSettings } from "@/components/data-table/hooks/useDataTableSettings";
import { PageCard } from "@/components/PageCard";
import { CardContent } from "@/components/ui/card";

export interface InMemoryTableContentProps extends PropsWithChildren {
  onResize?: (size: DOMRectReadOnly) => void;
  onScroll?: (left: number, top: number) => void;
  className?: string;
  footer?: React.ReactNode;
  isInDialog?: boolean;
}

export const InMemoryTableContent = memo(
  <T extends { id: string }>({
    children,
    onResize,
    onScroll,
    className,
    footer,
    isInDialog,
  }: InMemoryTableContentProps) => {
    const { features } = useDataTableSettings<T>();

    const innerContent = (
      <>
        <div className="flex flex-col gap-2 border min-h-32 h-full">
          <DataTable
            getRowProps={features.getRowProps}
            onResize={onResize}
            onScroll={onScroll}
            footer={footer}
            isInDialog={isInDialog}
          />
        </div>
        {children}
      </>
    );

    return (
      <PageCard className={className}>
        <CardContent className="flex flex-col gap-2 p-2 justify-between grow h-full">
          {features.editionHighlight ? (
            <FormTableCellDirtyProvider
              baseline={features.editionHighlight.baseline}
              recordKey={features.editionHighlight.recordKey}
            >
              {innerContent}
            </FormTableCellDirtyProvider>
          ) : (
            innerContent
          )}
        </CardContent>
      </PageCard>
    );
  },
);
